/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-splash.js
 *
 * ロード後に実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);

/**
 * actionToSplash
 * 全ページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplash() {
  //var
  var body = document.body;
  var headerLogo = document.getElementById('site-h__logo');
  var headerEntryNav = document.getElementById('site-h_entry-nav');
  var dNavBtn = document.getElementById('d-nav-btn');

  var tl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "power4.out"
    },
  });

  //to
  tl.to([body], {
    opacity: 1,
    duration: 0.5,
  })
}


/**
 * actionToPageMove
 * ページ遷移時アクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToPageMove() {

  var maskTl = gsap.timeline({
    defaults: {
      duration: 0.5,
      ease: "power4.out"
    },
  });

  let mask = document.getElementById("mask");

  maskTl.to(mask, {
    opacity: 1,
  });
}

/**
 * actionToSplash
 * 初回読み込み用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToFirstSplash() {}

/**
 * actionToSplashHome
 * TOPページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplashHome() {

  var homeTl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "power4.out"
    },
  });

  //var
  var mvCopyEn = document.querySelectorAll('.mv__copy .en span');
  var mvCopyEnLine = document.querySelectorAll('.mv__copy .en .line');
  var mvCopyJp1 = document.querySelectorAll('.mv__copy .jp .jp1 span');
  var mvCopyJp2 = document.querySelectorAll('.mv__copy .jp .jp2 span');
  var mvCopyJp3 = document.querySelectorAll('.mv__copy .jp .jp3 span');
  var mvVideo = document.getElementById('mvVideo');
  var scrollDown = document.querySelectorAll('.mv__scroll-down .scroll-down');

  //set
  gsap.set([mvCopyEn], {
    xPercent: -20,
    opacity: 0,
  });
  gsap.set([mvCopyJp1, mvCopyJp2, mvCopyJp3], {
    yPercent: 100,
    opacity: 0,
  });
  gsap.set([mvCopyEnLine], {
    scaleX: 0,
  })
  gsap.set([scrollDown], {
    opacity: 0,
  })

  //to
  homeTl
    .to([scrollDown], {
      scale: 1,
      opacity: 1,
      delay: 0.5,
    })
    .to([mvCopyEn, mvCopyJp1, mvCopyJp2, mvCopyJp3], {
      xPercent: 0,
      yPercent: 0,
      opacity: 1,
      stagger: {
        from: "start",
        amount: 0.5
      }
    }, "<")
    .to([mvCopyEnLine], {
      scale: 1,
    }, "-=0.5");
}

/**
 * actionToSplashLower
 * 下層ページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplashLower() {

  var lowerTl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "power4.out"
    },
  });

  //var
  var ttlText = document.querySelectorAll('.ttl__text .slide__up__train');
  var ttlMv = document.querySelectorAll('.ttl__mv.clip__bottom');
  var breadcrumb = document.querySelectorAll('.breadcrumb .slide__left');
  var content = document.querySelectorAll('.entry__content');

  gsap.set([content], {
    opacity: 0,
  })

  //to
  lowerTl
    .to([ttlMv], {
      clipPath: `inset(0 0 0 0)`,
    })
    .to([ttlText, ttlMv, breadcrumb], {
      yPercent: 0,
      xPercent: 0,
      scale: 1,
      opacity: 1,
      delay: 0.5,
      clipPath: `inset(0 0 0 0)`,
      stagger: {
        from: "start",
        amount: 0.5
      }
    }, "-=0.4")
    .to(content, {
      opacity: 1,
    }, "<");
}

/**
 * actionToSplashLower
 * インタビューページ用スプラッシュアクション
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
function actionToSplashInterview() {

  var lowerInterviewTl = gsap.timeline({
    defaults: {
      duration: 1,
      ease: "power4.out"
    },
  });

  //var
  var interviewBoxCard = document.querySelectorAll('.interview__card');
  var ttlText = document.querySelectorAll('.ttl__text .slide__up__train');
  var breadcrumb = document.querySelectorAll('.breadcrumb .slide__left');
  var content = document.querySelectorAll('.entry__content');

  gsap.set([content], {
    opacity: 0,
  })

  gsap.set([interviewBoxCard], {
    yPercent: 50,
    opacity: 0,
  })

  //to
  lowerInterviewTl
    .to([ttlText, breadcrumb], {
      yPercent: 0,
      xPercent: 0,
      scale: 1,
      opacity: 1,
      delay: 0.5,
      clipPath: `inset(0 0 0 0)`,
      stagger: {
        from: "start",
        amount: 0.5
      }
    }, "-=0.4")
    .to(content, {
      opacity: 1,
    }, "<")
    .to([interviewBoxCard], {
      yPercent: 0,
      opacity: 1,
      stagger: {
        from: "start",
        amount: 0.5
      }
    }, "<")
}

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export {
  actionToSplash,
  actionToSplashHome,
  actionToSplashLower,
  actionToSplashInterview
};